import React from 'react';
import { useLocale } from '../i18n/LocaleProvider';
import { LOCALES } from '../i18n/pick';

export default function LocaleSwitcher() {
  const { locale, setLocale } = useLocale();

  return (
    <div
      role="group"
      aria-label="Language"
      className="inline-flex items-center rounded-full border border-sand bg-cream/70 p-0.5 font-num text-[11px] uppercase tracking-wider"
    >
      {LOCALES.map((code) => {
        const active = code === locale;
        return (
          <button
            key={code}
            type="button"
            onClick={() => setLocale(code)}
            aria-pressed={active}
            className={
              'rounded-full px-2.5 py-1 transition-colors ' +
              (active
                ? 'bg-greenDeep text-cream'
                : 'text-greenDeep/60 hover:text-greenDeep')
            }
          >
            {code}
          </button>
        );
      })}
    </div>
  );
}
